import React from "react";

/**
 * @deprecated Legacy no-op kept temporarily so old page-level imports do not render a second modal.
 * The HubSpot meeting modal is now mounted globally from App.tsx.
 */
const CalendlyModal: React.FC<{ isOpen: boolean; onClose: () => void }> = () => null;

export default CalendlyModal;
